export default __webpack_public_path__ + "static/media/social.90efc33f.svg";